/* Medite premium polish: scroll reveal for below-the-fold sections on product pages.
   Classes are applied only after JS runs, so a JS failure leaves everything visible. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  function init() {
    var main = document.getElementById('main-content');
    if (!main) return;
    var sections = main.querySelectorAll('.shopify-section');
    if (sections.length < 3) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mp-fade-in');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });

    // Skip the first two sections so the above-the-fold render is untouched.
    for (var i = 2; i < sections.length; i++) {
      var rect = sections[i].getBoundingClientRect();
      /* Very tall sections (e.g. the Argan page's long details block) never reach a visibility ratio,
         so they stayed invisible until scrolled far down. Never fade those. */
      if (rect.height > window.innerHeight * 1.5) continue;
      /* Sections holding a position:fixed sticky bar must never get a transform (it would pin the bar
         to the section instead of the screen and it would never appear). */
      if (sections[i].querySelector('[id$="-sticky"], [id="inv-sticky"]')) continue;
      if (rect.top > window.innerHeight) {
        sections[i].classList.add('mp-fade');
        observer.observe(sections[i]);
      }
    }
    /* Safety net: sections that grew tall after load (images/fonts) are revealed, never left hidden. */
    setTimeout(function () {
      main.querySelectorAll('.mp-fade:not(.mp-fade-in)').forEach(function (el) {
        if (el.getBoundingClientRect().height > window.innerHeight * 1.5) el.classList.add('mp-fade-in');
      });
    }, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
